EventTarget.prototype.csAddEvent = EventTarget.prototype.addEventListener;

Object.assign(NodeList.prototype, {
  csRemoveClass: function() {
    for (const item of this) {
      item.classList.remove(...arguments);
    }
  },
  csAddClass: function() {
    for (const item of this) {
      item.classList.add(...arguments);
    }
  },
  csAddEvents: function(...args) {
    for (const item of this) {
      item.csAddEvent(...args);
    }
  },
});

Object.assign(HTMLElement.prototype, {
  cdRemoveClass: function(...args) {
    this.classList.remove(...args);
  },
  csAddClass: function(...args) {
    this.classList.add(...args);
  },
  csHasClass: function(className) {
    return this.classList.contains(className);
  }
});


class ProductBundle extends HTMLElement {
  constructor() {
    super()
    this.collectionsSwitcher = this.querySelectorAll('[js-collection-switcher]');
    this.collectionTitle = this.querySelector('[js-collection-title-wrapper]');
    this.bundleModalTrigger = this.querySelector('[js-bundle-modal]');
    this.selectVariantBtn = this.querySelectorAll('[js-select-variant-btn]');
    this.variantWrapperSelector = this.querySelector('[js-variants-wrapper]');
    this.collectionWrapper = this.querySelector('[js-collections-wrapper]');
    this.productImageWrapper = this.querySelector('[js-images-wrapper]');
    this.sizeVariant = this.querySelector('[js-size-variant]');
    this.addToCartBtn = this.querySelector('[js-add-to-cart-btn]');
    this.selectionCountBtn = this.querySelector('[js-selection-count-btn]');
    this.bundlePrice = this.querySelector('[js-bundle-price]');
    this.selectionLimitWrapper = this.querySelectorAll('[js-selection-limit]');
    this.selectedVariantCount = this.querySelector('[js-selected-variant-count]');
    this.productSelectionBoxSelector = this.querySelector('[js-boxes-wrapper]');
    this.boxesBtn = this.querySelectorAll('[js-box-btn]');
    this.boxLimitTriggerButton = this.querySelectorAll('[js-box-limit-trigger-btn]');
    this.sizeChart = this.querySelector("[js-ajax-size-chart]");
    this.sizeCalculator = this.querySelector("[js-size-calculator]");
    this.boxLimitAndDiscountText = this.querySelector('[js-box-limit-and-discount]');
    this.productSwitcherSelector = '[js-product-switcher]';
    this.variantSwitcherSelector = '[js-variant-switcher]';
    this.collectionsWrapperSelector = '[js-collections-wrapper]';
    this.variantsWrapperSelector = '[js-variants-wrapper]';
    this.imagesWrapperSelector = '[js-images-wrapper]';
    this.productBoxSelectorImageSelector = '[js-box-img]';
    this.productBoxSelectorTitleSelector = '[js-box-title]';
    this.productBoxSelectorSizeSelector = '[js-box-size]';
    this.productBoxSelector = '[js-box]';
    this.productRemoveBtnSelector = '[js-remove-product-btn]';
    this.productTitleSelector =  '[js-product-title]';


    this.nextNav = this.querySelector('[data-next-nav]');
    this.prevNav = this.querySelector('[data-prev-nav]');
    this.atcSpinner = this.querySelector('[js-atc-spinner]');
    this.navStep = this.querySelectorAll('[data-step]');
    this.jsCollectionGrid = this.querySelector('[js-collection-grid]');
    this.atcWrapperSelector = this.querySelector('[js-bundle-atc-wrapper]'); 
    this.savingsSelector = this.querySelector('[data-savings]'); 
    this.priceSelector = this.querySelector('[data-total-price]');
    this.comparePriceSelector = this.querySelector('[data-total-compare-price]');
    this.savingAmount = this.querySelector('[data-saving-price]');
    this.collectionsCategories = this.querySelectorAll('[data-category-title]');
    this.boxCategoryEls = this.querySelectorAll('[js-box-limit-trigger-btn]');
    
    this.selectedVariants = [];
    this.selectionLimitBox = 3;

    this.buildProductSelectionBox(this.selectionLimitBox);
    this.selectionLimitWrapper.forEach(totalBoxWrapper => {
      totalBoxWrapper.textContent = this.selectionLimitBox;
    })
    
    this.selectedVariantCount.textContent = 0;
    
    this.csAddEvent('click', (e) => {

      if(e.target.hasAttribute("js-bundle-modal-trigger")) {
        if(this.bundleModalTrigger.classList.contains("is-open")){
          this.bundleModalTrigger.classList.remove("is-open")
        }else{
          this.bundleModalTrigger.classList.add("is-open")
        }
      }
      if(e.target.hasAttribute("js-box-limit-trigger-btn")) {
        const box = parseInt(e.target.getAttribute("data-box-number"));
        this.querySelector("[js-selection-box-label]").textContent = box + " pack"
        this.boxCategoryEls.forEach(el => el.classList.remove("selected"));
        this.collectionsSwitcher.forEach(el => el.classList.remove("selected"));
        e.target.classList.add("selected");
        const boxxess = parseInt(this.querySelector("[js-box-limit-trigger-btn].selected").getAttribute("data-box-number"));
        this.updateBtn(boxxess);
        this.selectVariantBtn.forEach((selectVariantBtn) => {
          selectVariantBtn.classList.add("hidden")
        })
        this.resetPack();
        this.changeLimit(this.selectedVariants, box);
        this.collectionWrapper.classList.add("is-hide")
            this.atcWrapperSelector.classList.add("is-hide")
            this.variantWrapperSelector.classList.add("is-hide")
            this.collectionTitle.textContent = ""

      }

       if(this.prevNav.contains(e.target)) {
            let currentActive = document.querySelector('.active[data-step]');
            let currentActiveContents = document.querySelectorAll('.current[data-step-content]');
            if(currentActive && currentActive.getAttribute('data-step') != '1') {
              
               currentActive.classList.remove('active');

               if(currentActive.previousElementSibling) {

                 let stepType = currentActive.previousElementSibling.getAttribute('data-type');
                 if(stepType != undefined && stepType != null) {
                   this.handleUrl(stepType, '', 'remove');
                 }
                 
                  currentActive.previousElementSibling.classList.add('active');
                  currentActive.previousElementSibling.classList.remove('done');
               }
            }
            currentActiveContents.forEach(content => {
              if(content.getAttribute('data-step-content') != '1') {
                content.classList.remove('current');
              }
            });
            if(currentActiveContents[0].previousElementSibling) {
              currentActiveContents[0].previousElementSibling.classList.add('current');
            }
            if(this.nextNav) {
               this.nextNav.classList.remove('hide');
            }
            if(currentActive.getAttribute('data-step') == '1') {
                if(document.querySelector('[data-initial-step]')) {
                  this.handleUrl('category', '', 'remove');
                  document.querySelector('[data-initial-step]').classList.add('active');
                }
                if(document.querySelector('[data-next-step]')) {
                  document.querySelector('[data-next-step]').classList.remove('active');
                }
            }


         if(document.querySelector(`[data-image-slider]`)) {
                document.querySelector(`[data-image-slider]`).classList.add('hidden');
             } 
             if(document.querySelector(`[data-single-image]`)) {
                document.querySelector(`[data-single-image]`).classList.remove('hidden');
             } 
         
       }

       this.collectionsCategories.forEach(collectionsCategory => {
       
          if(collectionsCategory.contains(e.target)) {
            const boxxes = parseInt(this.querySelector("[js-box-limit-trigger-btn].selected").getAttribute("data-box-number"));
            this.updateBtn(boxxes);
            if(window.innerWidth < 767){
              this.selectVariantBtn.forEach((selectVariantBtn) => {
                selectVariantBtn.classList.add("hidden")
              })
            }
            let categoryTitle = collectionsCategory.dataset.categoryTitle;
            this.collectionsCategories.forEach(colCate => {
              colCate.classList.remove("selected")
            })
            this.collectionWrapper.classList.add("is-hide")
            this.atcWrapperSelector.classList.add("is-hide")
            this.variantWrapperSelector.classList.add("is-hide")
            this.jsCollectionGrid.classList.remove("is-hide")
            this.collectionTitle.textContent = ""
            this.querySelectorAll(this.variantSwitcherSelector).forEach(variantSwitcher => {
              variantSwitcher.classList.remove("selected")
            })
            this.sizeVariant.textContent = ""
            collectionsCategory.classList.add("selected")
            this.handleUrl('category', categoryTitle);
            this.handleUrl('collection-handle', '', 'remove');
            this.handleUrl('size', '', 'remove');
             let tempValue = true;
            this.collectionsSwitcher.forEach(collectionSwitcher => {
              const boxess = parseInt(this.querySelector("[js-box-limit-trigger-btn].selected").getAttribute("data-box-number"));
              this.updateBtn(boxess);
              if(window.innerWidth < 767){
                this.selectVariantBtn.forEach((selectVariantBtn) => {
                  selectVariantBtn.classList.add("hidden")
                })
              }
              let collCategory = collectionSwitcher.getAttribute('data-collection-category');
              collectionSwitcher.classList.remove('selected');
              if(collCategory == categoryTitle) {
                collectionSwitcher.classList.remove('hidden');
                if(tempValue) {
                  tempValue = false;
                }
              }    
              else {
                 collectionSwitcher.classList.add('hidden');
              }
              
            });
           
            
            if(document.querySelector('[data-initial-step]')) {
              document.querySelector('[data-initial-step]').classList.remove('active');
            }
            if(document.querySelector('[data-next-step]')) {
              document.querySelector('[data-next-step]').classList.add('active');
            }

            this.updateSizeCalculator(collectionsCategory.getAttribute("data-category"))

            const collectionTitle = this.querySelector(`[js-collection-switcher].selected`).dataset.collectionTitle;
            this.collectionTitle.textContent = collectionTitle;
          }
       });
      
       this.collectionsSwitcher.forEach(collectionSwitcher => {
        if(collectionSwitcher.contains(e.target)) {

          
          this.collectionsSwitcher.csRemoveClass('selected');
          collectionSwitcher.csAddClass('selected');
          this.variantWrapperSelector.classList.remove("is-hide")
          const collectionHandle = collectionSwitcher.dataset.collectionHandle;
          const collectionTitle = collectionSwitcher.dataset.collectionTitle;
          this.collectionTitle.textContent = collectionTitle;
          this.querySelectorAll(this.variantSwitcherSelector).forEach(variantSwitcher => {
            variantSwitcher.classList.remove("selected")
          })
          this.sizeVariant.textContent = ""
          this.collectionWrapper.classList.add("is-hide")
          this.atcWrapperSelector.classList.add("is-hide")
          
               this.handleUrl('collection-handle', collectionHandle);

                if(this.variantsWrapperSelector) {
                   document.querySelector(this.variantsWrapperSelector).classList.add('current');
                }
                if(this.jsCollectionGrid) {
                   this.jsCollectionGrid.classList.remove('current');
                }
            
                if(document.querySelector('[data-step="1"]')) {
                    document.querySelector('[data-step="1"]').classList.remove('active');
                    document.querySelector('[data-step="1"]').classList.add('done');
                }
                if(document.querySelector('[data-step="2"]')) {
                   document.querySelector('[data-step="2"]').classList.add('active');
                }
            
                if(this.prevNav) {
                   this.prevNav.classList.remove('disabled');
                }
          
          this.updateSizeChart(collectionHandle)
        }
      })

       this.querySelectorAll(this.productSwitcherSelector).forEach(productSwitcher => {
        if(productSwitcher.contains(e.target)) {

          this.querySelectorAll(this.productSwitcherSelector).csRemoveClass('active');
          productSwitcher.csAddClass('active');
          this.querySelector(this.productTitleSelector).textContent = productSwitcher.dataset.productTitle;
          const productHandle = productSwitcher.dataset.productHandle;
          const url = `${location.origin}/products/${productHandle}?view=productBundleAjax`;
          this.fetchData(url, (ajaxContainer) => {
            this.renderProduct.bind(this, [this.variantsWrapperSelector, this.imagesWrapperSelector], ajaxContainer)();
            this.atcWrapperSelector.classList.remove("is-hide");
            this.selectVariantBtn.forEach((selectVariantBtn) => {
                if(selectVariantBtn.classList.contains("bundle-btn-new")){
                  selectVariantBtn.classList.remove("hidden")
                }
              })
            if(window.innerWidth < 767){
              this.selectVariantBtn.forEach((selectVariantBtn) => {
                selectVariantBtn.classList.remove("hidden")
              })
              this.selectionCountBtn.classList.add("hidden")
            }
          })
        }
      })
  
       this.querySelectorAll(this.variantSwitcherSelector).forEach(variantSwitcher => { 


    

         if(variantSwitcher.contains(e.target)) {
          this.atcWrapperSelector.classList.add("is-hide")
          const boxes = parseInt(this.querySelector("[js-box-limit-trigger-btn].selected").getAttribute("data-box-number"));
          this.updateBtn(boxes);
          if(window.innerWidth < 767){
            this.selectVariantBtn.forEach((selectVariantBtn) => {
              selectVariantBtn.classList.add("hidden")
            })
          }
          this.querySelector(".bundle-section-product-wrap").classList.add("loading")
          this.querySelectorAll(this.variantSwitcherSelector).csRemoveClass('selected');
          variantSwitcher.csAddClass('selected');
          this.collectionWrapper.classList.remove("is-hide")
          this.sizeVariant.textContent = variantSwitcher.dataset.variantSize
          let selectedSize = variantSwitcher.innerText.toLowerCase();
          this.handleUrl('size', selectedSize);
          const collectionHandle = this.querySelector(`[js-collection-switcher].selected`).dataset.collectionHandle;
          const url = `${location.origin}/collections/${collectionHandle}?view=collectionBundleAjax`; 
          this.fetchData(url, (ajaxContainer) => {
            this.renderCollection.bind(this, [this.collectionsWrapperSelector], ajaxContainer , selectedSize)();
        
          })
          
        }
      })

      this.selectVariantBtn.forEach((selectVariantBtn) =>  {
        if(selectVariantBtn.contains(e.target)) {
          const variantId = this.querySelector(`${this.productSwitcherSelector}.active`).dataset.variantId;
          const variantPrice = this.querySelector(`${this.productSwitcherSelector}.active`).dataset.variantPrice;
          const variantImgUrl = this.querySelector(`${this.productSwitcherSelector}.active`).dataset.variantImgUrl;
          const productTitle = this.querySelector(`${this.productSwitcherSelector}.active`).dataset.variantTitle;
          const variantTitle = this.querySelector(`${this.productSwitcherSelector}.active`).dataset.variant;
          
          this.selectedVariants.push({
            id: Number(variantId),
            price: Number(variantPrice),
            imgUrl: variantImgUrl,
            productTitle: productTitle,
            variantTitle: variantTitle,
          });
          this.fillProductInSelectionBox(this.selectedVariants);
          // this.collectionsSwitcher.forEach((colSwitcher) => {
          //   colSwitcher.classList.remove("selected")
          // })
          // this.querySelectorAll(this.variantSwitcherSelector).forEach(variantSwitcher => {
          //   variantSwitcher.classList.remove("selected")
          // })
          if(window.innerWidth < 768){
            this.selectVariantBtn.forEach((selectVariantBtn) => {
              selectVariantBtn.classList.add("hidden")
            })
          }
          this.querySelectorAll(this.productSwitcherSelector).forEach((productSwitcher_) => {
            productSwitcher_.classList.remove("active")
          });
          document.querySelector(`[data-image-slider]`).classList.add('hidden');
          this.querySelector(this.productTitleSelector).textContent = ""
          // this.collectionWrapper.classList.add("is-hide")
           this.atcWrapperSelector.classList.add("is-hide")
          // this.variantWrapperSelector.classList.add("is-hide")
          // this.collectionTitle.textContent = '';
          // this.querySelector(this.productTitleSelector).textContent = '';
          // this.sizeVariant.textContent = ''
  
        }
      })
       

      this.querySelectorAll(this.productRemoveBtnSelector).forEach(removeBtn => {
        if(removeBtn.contains(e.target)) {
          if(window.innerWidth < 768){
            this.selectVariantBtn.forEach((selectVariantBtn) => {
              selectVariantBtn.classList.add("hidden")
            })
            this.querySelectorAll(this.productSwitcherSelector).forEach((productSwitcher_) => {
              productSwitcher_.classList.remove("active")
            });
            document.querySelector(`[data-image-slider]`).classList.add('hidden');
            this.querySelector(this.productTitleSelector).textContent = ""
          }
          const parent = removeBtn.closest('.selected-items-list');
          const index = parseInt(parent.dataset.index);
          this.selectedVariants.splice(index, 1)
          this.fillProductInSelectionBox(this.selectedVariants);
        }
      })

      if(this.addToCartBtn.contains(e.target)) {
        this.addToCartBtn.classList.add('btn--loading');
        this.atcSpinner.classList.remove("hidden")
        const productsId = [];
        const products = [];
        this.selectedVariants.forEach(item => {
          if(productsId.indexOf(item.id) === -1) {
            productsId.push(item.id)
            products.push({
              id: item.id,
              quantity: 1
            })
          } else { 
            products[productsId.length - 1].quantity += 1;
          }
         
        })
        this.addToCart(products);
      }
    })
   // this.querySelector(this.imagesWrapperSelector).style.opacity = 1;

  }


  handleUrl(name, value, remove) {
    let pageUrl = new URL(location);
    if(remove != null && remove != undefined) {
       pageUrl.searchParams.delete(name);
    }
    else {
      name === "collection-handle" ? pageUrl.searchParams.set(name, value.charAt(0).toUpperCase() + value.slice(1)) : pageUrl.searchParams.set(name, value);
    }
    history.pushState({}, "", pageUrl);
  }
  
  renderCollection(currentContainerSelector, ajaxContainer, selectedSize) {
    const currenVariatSwitcher = ajaxContainer.querySelectorAll('[js-product-switcher]');
    currenVariatSwitcher.forEach(switcher => {
        const seitcherSize = switcher.getAttribute('data-variant');
        if (selectedSize === seitcherSize) {
          switcher.classList.remove('hidden')
        }else {
          switcher.classList.add('hidden')
        }
    })
    this.querySelector(currentContainerSelector[0]).innerHTML = ajaxContainer.querySelector(this.collectionsWrapperSelector).innerHTML;

    this.querySelector(".bundle-section-product-wrap").classList.remove("loading")
    if(this.querySelector(`${this.productSwitcherSelector}.active`)) {
       const productHandle = this.querySelector(`${this.productSwitcherSelector}.active`).dataset.productHandle;  
        const url = `${location.origin}/products/${productHandle}?view=productBundleAjax`;
        this.fetchData(url, (ajaxContainer) => {
          this.renderProduct.bind(this, [this.variantsWrapperSelector, this.imagesWrapperSelector], ajaxContainer)();
       })
    }
    
  }

  renderProduct(currentContainerSelector, ajaxContainer) {
    this.querySelector(currentContainerSelector[1]).replaceWith(ajaxContainer.querySelector(this.imagesWrapperSelector));
    document.dispatchEvent(new CustomEvent('mainProductSlder:init'));
      document.dispatchEvent(new CustomEvent("size-chart:init"));
      document.dispatchEvent(new CustomEvent("size-chart-parameters:init"));
      const imageWrapper = this.querySelector("[js-images-wrapper]")
      imageWrapper.classList.remove("is-hide")
  }

  updateSizeCalculator(category) {
    const sizeHtml = `
     <span fmf-widget-manager 
        product-image-url="https://" 
        product-url="/products/cotton-linen-purple-kurta-pant-set"
        product-price="349" 
        product-description="" 
        enterprise-currency="INR" 
        style="display:inline-block;">
    </span>
    `

    this.sizeCalculator.querySelector("[fmf-widget-manager]")?.remove();
    this.sizeCalculator?.insertAdjacentHTML("afterbegin", sizeHtml);
    const widgetManager = this.sizeCalculator?.querySelector("[fmf-widget-manager]");

    if(category === "men") {
      widgetManager?.setAttribute("product-code", "BMM-Men-Boxers");
    }else {
      widgetManager?.setAttribute("product-code", "BMM-Women-Bikini")
    }

    bootstrapSizeNFitComWidgetAuto();
  };

  updateSizeChart(style) {
    if(!style) return;
    
    const url = `${location.href}&section_id=${this.getAttribute("data-section-id")}`;
    this.querySelector("[js-size-chart-trigger]")?.classList.add("disabled");

    fetch(url)
    .then( response => response.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const ajaxSizeChart = doc.querySelector("[js-ajax-size-chart]");
      this.sizeChart.innerHTML = ajaxSizeChart.innerHTML;
      
      document.dispatchEvent(new CustomEvent("size-chart:init"));
      document.dispatchEvent(new CustomEvent("size-chart-parameters:init"));
    })
    .catch(function(error) {
      console.log(error);
    });
  }

  async fetchData(url, renderHtml) {
    const resp = await fetch(url);
    const html = await resp.text();
    const parse =  new DOMParser();
    const ajaxDocs = parse.parseFromString(html, 'text/html');
    renderHtml(ajaxDocs)
  }

  buildProductSelectionBox(boxNumber, disableBox, addMoreText) {
    this.updateBtn();
    this.productSelectionBoxSelector.innerHTML = '';
    let productbox = '';
    for (let i = 0; i < boxNumber; i++) { 
      productbox += `<div js-box data-index="${i}" class="selected-items-list align-center justify-between ${ (boxNumber-1) == i && addMoreText != '' && (addMoreText != undefined) ? 'add-more-box': '' } ${ disableBox == true && (boxNumber-1) == i ? 'disabled-box' : '' }">
            <div class="selected-item align-center">
              <div class="bundle_section__small-img">
                  <img js-box-img data-index="${i}" src="https://cdn.shopify.com/s/files/1/0231/1448/1744/files/2_1.png?v=1726726229" alt="">
              </div>
              <div class="bundle_section__small-svg">
                  <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_4922_1983)">
                      </g>
                      <rect x="0.5" y="0.5" width="71" height="71" rx="4.5" stroke="black" stroke-dasharray="5 5"/>
                      <defs>
                      <clipPath id="clip0_4922_1983">
                      <rect x="1" y="1" width="70" height="70" rx="4" fill="white"/>
                      </clipPath>
                      </defs>
                  </svg>
              </div>
              <div class="selected-item-inner">
                  <h3 class="selected-item_title" js-box-title data-index="${i}">Add a Pair</h3>
                  <div class="seclected-item-wrap">
                      <div class="selected-item_size" >Size: <span class="selected_Size-value" js-box-size data-index="${i}">Large</span></div>
                  </div>
              </div>
          </div>
          <div class="remove-item-btn" js-remove-product-btn>Remove</div>
      </div>`
    }
      
    this.productSelectionBoxSelector.insertAdjacentHTML('beforeend', productbox)
  }

  fillProductInSelectionBox(products) {
    const box = parseInt(this.querySelector("[js-box-limit-trigger-btn].selected").getAttribute("data-box-number"));
    this.changeLimit(products, box);
    this.updateBtn(box);
    products.forEach((item, index) => {
      this.querySelector(`${this.productBoxSelectorImageSelector}[data-index="${index}"]`).src = item.imgUrl;
      this.querySelector(`${this.productBoxSelectorImageSelector}[data-index="${index}"]`).alt = item.productTitle;
      this.querySelector(`${this.productBoxSelectorImageSelector}[data-index="${index}"]`).title = item.productTitle;
      this.querySelector(`${this.productBoxSelector}[data-index="${index}"]`).classList.add('selected');
      this.querySelector(`${this.productBoxSelector}[data-index="${index}"]`).setAttribute('data-variant-id', item.id)
      this.querySelector(`${this.productBoxSelectorTitleSelector}[data-index="${index}"]`).textContent = item.productTitle;
      this.querySelector(`${this.productBoxSelectorSizeSelector}[data-index="${index}"]`).textContent = item.variantTitle;
    })
  }

  resetPack() {
    this.selectedVariants = [];
  }

  changeLimit(products, limit) {
     let disabledClass = false;
     let addMoreText = '';
     let boxLimit = limit;
     this.selectionLimitBox = limit;
     
     let discountPercentage = 20;
     let savingsHTML = 'SAVE 20%';
     if(products.length == boxLimit){
      this.selectVariantBtn.forEach((selectVariantBtn) => {
        selectVariantBtn.classList.add("disabled")
      })
     }else{
      this.selectVariantBtn.forEach((selectVariantBtn) => {
        selectVariantBtn.classList.remove("disabled")
      })
     }
    if(boxLimit === 5){
      this.boxLimitAndDiscountText.textContent = "Buy 5, Save 25%";
    }else {
      this.boxLimitAndDiscountText.textContent = "Buy 3, Save 20%";
    }
     if(products.length == 0) {
        addMoreText = 'Choose Your first Pair';
        this.selectionCountBtn.classList.add("bundle-empty")
     }else{
      this.selectionCountBtn.classList.remove("bundle-empty")
     }
     if(products.length == 1) {
        addMoreText = 'Choose Your Second Pair';
     }
     if(products.length == 2) {
        addMoreText = 'Choose Your Third Pair';
     }
     if(products.length == 3) {
        addMoreText = 'Choose Your Fourth Pair';
     }
     if(products.length == 4) {
        addMoreText = 'Choose Your Fifth Pair';
     }
     if(boxLimit === 5) {
        discountPercentage = 25;
        savingsHTML = 'SAVE 25%';
     }else {
      discountPercentage = 20;
      savingsHTML = 'SAVE 20%';
     }
      this.savingsSelector.innerHTML = savingsHTML;
      this.selectionCountBtn.textContent = addMoreText;
      
      this.selectionLimitWrapper.forEach(totalBoxWrapper => {
          totalBoxWrapper.textContent = boxLimit;
      })

      
      let bundlePrice = 0;
      products.forEach((item, index) => {
        bundlePrice += item.price;
      });
      if(bundlePrice > 0) {
         let discountedPrice = bundlePrice;
         let discountPrice = (bundlePrice*discountPercentage)/100;
         discountedPrice = bundlePrice-discountPrice;
         this.priceSelector.innerHTML = `₹${discountedPrice / 100}`;
         this.comparePriceSelector.innerHTML = `₹${bundlePrice / 100}`;
         this.savingAmount.innerHTML = "₹" + discountPrice / 100;
         this.savingsSelector.classList.remove('hidden');
         this.comparePriceSelector.classList.remove('hidden');
         this.priceSelector.classList.add("has-price")
      }
      else {
        this.priceSelector.classList.remove("has-price")
        this.priceSelector.innerHTML = "---"
        this.savingAmount.innerHTML = "---";
        this.savingsSelector.classList.add('hidden');
         this.comparePriceSelector.classList.add('hidden');
      }
    
     this.buildProductSelectionBox(this.selectionLimitBox, disabledClass, addMoreText);
  }
  
  async addToCart(products) {
    const requestBody = {
      items: products
    }

    const cartDrawer = document.querySelector('cart-drawer');
    console.log(cartDrawer)
    requestBody.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
    
    try {
      const resp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await resp.json();

      this.addToCartBtn.classList.remove('btn--loading');
      this.atcSpinner.classList.add("hidden")

      cartDrawer.renderContents(data);
  
    } catch(err){
      console.log({ err })
    }
  }

  updateBtn(box) {


    this.selectedVariantCount.innerText = this.selectedVariants.length;

    let bundlePrice = 0;
    this.selectedVariants.forEach(item => {
      bundlePrice += item.price
    })
     if(this.selectedVariants.length == box) {
       this.addToCartBtn.classList.remove('hidden');
       this.selectionCountBtn.classList.add('hidden');
     }
    else {
      this.addToCartBtn.classList.add('hidden');
      this.selectionCountBtn.classList.remove('hidden');
    }
  }
}

customElements.define('product-bundle', ProductBundle);